module.exports = __webpack_public_path__ + "img/wheel_in2.cbf5ef05.png";